import { render, staticRenderFns } from "./TabBox.vue?vue&type=template&id=26dd501c&scoped=true&"
import script from "./TabBox.vue?vue&type=script&lang=ts&"
export * from "./TabBox.vue?vue&type=script&lang=ts&"
import style0 from "./TabBox.vue?vue&type=style&index=0&id=26dd501c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26dd501c",
  null
  
)

export default component.exports